import {writable, derived} from 'svelte/store';


export const hours_in_month = 720
export const slo = writable(99.99)

export let colors = [
    '#ef476f',
    '#ffd166',
    '#06d6a0',
    '#118ab2'
]

export let defaultAlertingWindows = [
    {
        time_window: 1,
        error_budget_burned_percent: 2,
        alert: 'Page'
    },
    {
        time_window: 6,
        error_budget_burned_percent: 5,
        alert: 'Page'
    },
    {
        time_window: 3 * 24,
        error_budget_burned_percent: 10,
        alert: 'Ticket'
    }
];

export let windows = writable(JSON.parse(JSON.stringify(defaultAlertingWindows)));

export function resetToDefaultAlertingWindows() {
    console.log('default', defaultAlertingWindows)
    windows.set(JSON.parse(JSON.stringify(defaultAlertingWindows)))
}

resetToDefaultAlertingWindows()


export function calcBurnRate(timeWindow, errorBudgetBurned) {
    return (errorBudgetBurned / 100) / (timeWindow / hours_in_month)
}


export function calcFireAfter(slo, windows, error_rate) {
    let result = {
        fire_after: 0,
        cost: 0,
        alert: "",
        window_idx: -1
    }

    windows.forEach((window, idx) => {
        let timeWindowHours = window.time_window
        let errorBudgetBurned = window.error_budget_burned_percent
        let burn_factor = (errorBudgetBurned / 100) / (timeWindowHours / hours_in_month)
        let threshold = (100 - slo) * burn_factor

        let fireAfterSeconds = Math.round((threshold / error_rate) * timeWindowHours * 3600)
        if (fireAfterSeconds > timeWindowHours * 3600) fireAfterSeconds = 0
        if (result.fire_after === 0 || fireAfterSeconds < result.fire_after) {
            result.fire_after = fireAfterSeconds
            if (fireAfterSeconds > 0) {
                result.cost = errorBudgetBurned
                result.alert = window.alert
                result.window_idx = idx
            }
        }
    })
    return result
}

export function calculate(slo, windows, error_rates, all = false) {
    let data = []
    // chartLabels = []
    // chartValues = []
    error_rates.forEach(error_rate => {
        let fa = calcFireAfter(slo, windows, error_rate)
        if (all || fa.fire_after > 0) {
            data.push(
                {
                    error_rate: error_rate,
                    fire_after: fa.fire_after,
                    cost: fa.cost,
                    alert: fa.alert,
                    window_idx: fa.window_idx
                })
        }
    })
    return data
}

// Function convert second into day
// hours, minutes and seconds
export function convertSectoDay(n) {
    var day = parseInt(n / (24 * 3600));

    n = n % (24 * 3600);
    var hour = parseInt(n / 3600);

    n %= 3600;
    var minutes = n / 60;

    n %= 60;
    var seconds = n;

    let parts = []
    if (day >= 1) {
        parts.push(day + "d")
    }
    if (hour >= 1) {
        parts.push(hour + "h")
    }
    if (minutes >= 1) {
        parts.push(minutes.toFixed() + "m")
    }
    if (seconds >= 1) {
        parts.push(seconds.toFixed() + "s")
    }

    return parts.join('')

}

